<div class="page contact">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 page-title">
                <h1>{{title}}</h1>
            </div>
        </div>
        <div class="row">
            <!-- <app-contact-item [contactItem]="location" class="col-md-4 contact-data"></app-contact-item> -->
            <!-- <app-contact-item [contactItem]="skype" class="col-md-4 contact-data"></app-contact-item> -->
            <app-contact-item [contactItem]="email" class="col-md-6 contact-data"></app-contact-item>
            <app-contact-item [contactItem]="whatsapp" class="col-md-6 contact-data"></app-contact-item>
        </div>
    </div>
</div>
